var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSideFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 9,
    viewBox: "0 0 6 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.31998 5.12869C5.64537 4.81632 5.64537 4.30903 5.31998 3.99666L1.98795 0.797991C1.74846 0.568087 1.39183 0.500616 1.07945 0.625564C0.767072 0.750511 0.564026 1.04039 0.564026 1.36526L0.566629 7.76259C0.566629 8.08495 0.769675 8.37733 1.08205 8.50228C1.39443 8.62723 1.75106 8.55726 1.99055 8.32985L5.32258 5.13118L5.31998 5.12869Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSideFill);
export default __webpack_public_path__ + "static/media/sideFill.19bab72c9003fe6447f4ff27724d9f2d.svg";
export { ForwardRef as ReactComponent };